import { Box, Center, Spinner } from '@chakra-ui/react';
import { DITable } from 'plugins/DITable';
import TablePagination from 'plugins/DITable/Pagination';
import GlobalCategoriesToolbar from './Toolbar';
import GlobalCategoriesModal from './Modal/AddEditModal';
import useGlobalCategories from './useGlobalCategories';
import DeleteGlobalCategoryModal from './Modal/DeleteModal';

const GlobalCategoriesTab = () => {
    const {
        isGlobalCategoriesLoading,
        availableCategories,
        setAvailableCategories,
        dataToSubmit,
        setDataToSubmit,
        table,
        handleOpenModal,
        modalType,
        isModalOpen,
        setIsModalOpen,
        isClientCategoriesFetching,
        isGlobalCategoriesFetching,
        selectedCategories,
        handleDelete,
        clientCategories,
        deleteGlobalCategory,
        isDeleteOpen,
        handleCloseDelete,
        isDeleteLoading,
        handleDeleteGlobalCategory,
        isDeleteMultiple,
        deleteInitialRef,
        isExportLoading,
        isExportFetching,
        handleExportCategories
    } = useGlobalCategories();

    return (
        <Box mt="16px">
            <GlobalCategoriesToolbar
                {...{
                    table,
                    isGlobalCategoriesLoading,
                    handleOpenModal,
                    setDataToSubmit,
                    selectedCategories,
                    handleDelete,
                    handleExportCategories,
                    isExportLoading,
                    isExportFetching,
                    setAvailableCategories,
                    clientCategories,
                }}
            />
            {isGlobalCategoriesFetching || isClientCategoriesFetching ? (
                <Center w="100%" h="200px" bg="white" border="1px solid" borderColor="gray.100">
                    <Spinner />
                </Center>
            ) : (
                <>
                    <DITable table={table} isPagination isHeaderFixed />
                    <TablePagination table={table} />
                    <GlobalCategoriesModal
                        {...{
                            dataToSubmit,
                            setDataToSubmit,
                            availableCategories,
                            setAvailableCategories,
                            deleteGlobalCategory,
                            isDeleteLoading,
                            isModalOpen,
                            setIsModalOpen,
                            modalType,
                        }}
                    />
                    <DeleteGlobalCategoryModal
                        {...{
                            isDeleteOpen,
                            handleCloseDelete,
                            isDeleteLoading,
                            handleDeleteGlobalCategory,
                            isDeleteMultiple,
                            deleteInitialRef,
                        }}
                    />
                </>
            )}
        </Box>
    );
};

export default GlobalCategoriesTab;
